function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m449.8 138.686-84.668 113.805 7.003 29.419 110.447-110.447c39.22-39.22 39.227-102.82 0-142.047L449.8 138.686z",
    style: {
      fill: "#98a09f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.535 29.418 230.089 139.864l38.608 9.469 8.741 37.88L387.881 76.769c13.054-13.054 34.295-13.054 47.349 0s13.054 34.295 0 47.349L324.786 234.561l38.243 9.106 2.102 8.824 99.239-99.239c39.22-39.22 47.379-94.668 18.211-123.835-39.226-39.226-102.826-39.219-142.046.001z",
    style: {
      fill: "#b6b8b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.252 361.748c13.053 13.053 34.295 13.053 47.349 0l164.147-164.147c13.053-13.053 13.053-34.296 0-47.349L150.252 361.748z",
    style: {
      fill: "#ced0ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.399 150.252c13.053-13.053 34.296-13.053 47.349 0 3.015 3.015-5.157 16.084-18.211 29.137L179.389 343.536c-13.053 13.053-26.122 21.227-29.137 18.211-13.053-13.053-13.053-34.296 0-47.349l164.147-164.146z",
    style: {
      fill: "#e7e7e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.686 449.8 113.805-84.668 29.419 7.003-110.447 110.447c-39.22 39.22-102.82 39.227-142.047 0l109.27-32.782z",
    style: {
      fill: "#98a09f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.418 340.536 139.864 230.09l9.469 38.608 37.88 8.741L76.769 387.881c-13.054 13.054-13.054 34.295 0 47.349 13.054 13.054 34.295 13.054 47.349 0l110.444-110.444 9.106 38.243 8.824 2.102-99.239 99.239c-39.22 39.22-94.668 47.379-123.835 18.211-39.227-39.226-39.22-102.826 0-142.045z",
    style: {
      fill: "#b6b8b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.27 148.996a7.702 7.702 0 0 1-5.464-2.263l-30.594-30.595a7.727 7.727 0 0 1 10.927-10.927l30.594 30.595a7.726 7.726 0 0 1 0 10.926 7.696 7.696 0 0 1-5.463 2.264zM184.976 134.427a7.725 7.725 0 0 1-7.726-7.726V83.434c0-4.267 3.458-7.726 7.726-7.726s7.726 3.459 7.726 7.726v43.267a7.726 7.726 0 0 1-7.726 7.726zM126.701 192.702H83.434c-4.268 0-7.726-3.459-7.726-7.726s3.458-7.726 7.726-7.726h43.267a7.726 7.726 0 1 1 0 15.452zM401.324 409.05a7.702 7.702 0 0 1-5.464-2.263l-30.594-30.595a7.726 7.726 0 1 1 10.927-10.926l30.594 30.595a7.726 7.726 0 0 1-5.463 13.189zM428.566 334.749h-43.267a7.725 7.725 0 0 1-7.726-7.726 7.725 7.725 0 0 1 7.726-7.726h43.267a7.725 7.725 0 0 1 7.726 7.726 7.725 7.725 0 0 1-7.726 7.726zM327.024 436.292a7.725 7.725 0 0 1-7.726-7.726v-43.267a7.725 7.725 0 0 1 7.726-7.726 7.725 7.725 0 0 1 7.726 7.726v43.267a7.726 7.726 0 0 1-7.726 7.726z",
    style: {
      fill: "#98a09f"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.aeaafcf6d195feb2f8dfa57a9b9f7b2c.svg";
export { ForwardRef as ReactComponent };